import { render, staticRenderFns } from "./PostSummary.vue?vue&type=template&id=229365b5&scoped=true&"
import script from "./PostSummary.vue?vue&type=script&lang=js&"
export * from "./PostSummary.vue?vue&type=script&lang=js&"
import style0 from "./PostSummary.vue?vue&type=style&index=0&id=229365b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229365b5",
  null
  
)

export default component.exports